import { render, staticRenderFns } from "./Data-Analysis.vue?vue&type=template&id=6429e871&scoped=true&"
import script from "./Data-Analysis.vue?vue&type=script&lang=js&"
export * from "./Data-Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Data-Analysis.vue?vue&type=style&index=0&id=6429e871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6429e871",
  null
  
)

export default component.exports